import React, { forwardRef, useEffect } from 'react';
import './input-select-product.scss';
export var InputSelectProduct = forwardRef(function (_a, ref) {
    var _b, _c, _d, _e;
    var id = _a.id, options = _a.options, required = _a.required, disabled = _a.disabled, error = _a.error, onChange = _a.onChange, setValue = _a.setValue, value = _a.value, productValue = _a.productValue;
    var selectClasses = 'c-form-select';
    var isGrouped = options ? (_d = ((_c = (_b = options[0]) === null || _b === void 0 ? void 0 : _b.category) === null || _c === void 0 ? void 0 : _c.length) > 0) !== null && _d !== void 0 ? _d : false : false;
    var renderOptionsGroup = function () {
        var optionsGrouped = {};
        options === null || options === void 0 ? void 0 : options.forEach(function (record) {
            var _a, _b;
            var arr = (_b = optionsGrouped[(_a = record.category) !== null && _a !== void 0 ? _a : '']) !== null && _b !== void 0 ? _b : [];
            arr.push(record);
            optionsGrouped[record.category] = arr;
        });
        return optionsGrouped;
    };
    useEffect(function () {
        if (value && setValue) {
            setValue(id, value);
        }
    }, [value]);
    if (error) {
        selectClasses += ' isInvalid';
    }
    if (required) {
        selectClasses += ' isRequired';
    }
    var renderOptions = function (items) {
        return items === null || items === void 0 ? void 0 : items.map(function (option, index) {
            var _a, _b, _c;
            return (React.createElement("option", { key: ((_a = option === null || option === void 0 ? void 0 : option.category) === null || _a === void 0 ? void 0 : _a.length) > 0 ? "".concat(option.category, "-").concat(option.id, "-").concat(index) : option.id, value: option.id, disabled: ((_b = option.selectable) !== null && _b !== void 0 ? _b : true) && !disabled ? false : true, selected: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id) === (option === null || option === void 0 ? void 0 : option.id) ? true : false }, (_c = option.displayText) !== null && _c !== void 0 ? _c : option.value));
        });
    };
    var groupings = isGrouped ? renderOptionsGroup() : {};
    var selectedOption = options.find(function (option) { return option.id === Number(productValue); });
    return (React.createElement("div", { className: "c-input-select-wrapper" },
        React.createElement("select", { name: id, id: id, className: selectClasses, ref: ref, required: required, "aria-invalid": error ? 'true' : 'false', "data-testid": "input-select", onChange: onChange },
            (value === '' || value === undefined || value === null) && (React.createElement("option", { value: "", selected: true }, "Please select")),
            isGrouped ? ((_e = Object.keys(groupings)) === null || _e === void 0 ? void 0 : _e.map(function (group) {
                return (React.createElement("optgroup", { key: group, label: group }, renderOptions(groupings[group])));
            })) : (React.createElement(React.Fragment, null,
                (value !== '' || value !== undefined || value !== null) && (React.createElement("option", { value: "", selected: true }, "Please select")),
                renderOptions(options))))));
});
InputSelectProduct.displayName = 'InputSelectProduct';
